import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=4923e928&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/page_style/contact.scss?vue&type=style&index=0&id=4923e928&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4923e928",
  null
  
)

export default component.exports